import { useRender } from '@base-ui/react/use-render'

import { cn } from '../../../../lib/utils.ts'

export function ItemIndicator(props: ItemIndicator.Props) {
  const { className, render, ref, ...rest } = props
  return useRender({
    render,
    ref,
    defaultTagName: 'span',
    props: {
      'data-slot': 'item-indicator',
      className: cn('[:where(&)]:size-4', className),
      ...rest,
      'aria-hidden': 'true',
    },
  })
}

export namespace ItemIndicator {
  export type Props = Omit<useRender.ComponentProps<'svg'>, 'children' | 'onClick' | 'tabIndex'>
}
